import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-export",
  "use": "icon-export-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-export\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M13.71,10V15H10.29V10H6L12,4,18,10ZM4.8,18.25H19.2v-6H21v6.88a.87.87,0,0,1-.9.85H3.9a.87.87,0,0,1-.9-.85V12.23H4.8Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol